import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import _get from 'lodash/get';
import moment from 'moment';
import PropTypes from 'prop-types';
import { Metadata } from 'web-media-ui-component';
import Tracking from 'utils/tracking';

class MetadataWrapper extends Component {

    onMetadataToggle = () => {
        Tracking.onMetadataToggle();
    }

    onShare = (type) => {
        Tracking.onShare(type);
    }

    onSearchTagClick = (query, tagUrl) => {
        const url = `${tagUrl.pathname}${tagUrl.search}`;
        Tracking.onSearchTagClick(query, url);
    }

    render() {

        const { clipData, lang, shareModalConfig, dictionary, mediaConfig } = this.props;
        const date = _get(clipData, 'date');
        const formatedDate = date ? moment(date).locale(lang).format('LL') : '';

        const metadata = {
            id: _get(clipData,'id'),
            image: _get(clipData,'image.cuts.0.src'),
            title: _get(clipData, 'title'),
            description: _get(clipData, 'description'),
            date: formatedDate,
            duration: _get(clipData, 'duration'),
            tags: _get(clipData, 'keywordsDisplay', []),
        };

        const embedInfo = _get(mediaConfig, 'vpm.socialSharing.embed.config', {});
        const urlTemplate = _get(embedInfo, 'urlTemplate') || '';

        const embedUrl = urlTemplate && urlTemplate.replace('{content_id}', metadata.id);
        const embedWidth = _get(embedInfo, 'tag.attributes[0].width', '');
        const embedHeight = _get(embedInfo, 'tag.attributes[1].height', '');
        const embedElement = embedUrl ? `<iframe src="${embedUrl}" width="${embedWidth}" height="${embedHeight}"></iframe>` : '';

        return (
            <Metadata
                id={metadata.id}
                image={metadata.image}
                title={metadata.title}
                description={metadata.description}
                date={metadata.date}
                duration={metadata.duration}
                tags={metadata.tags.map(tag => {

                    const tagUrl = {
                        pathname: '/search',
                        search: `?query=${encodeURIComponent(tag.displayName)}&tag=${tag.slug}`,
                    };

                    const tagText = tag.displayNameOverride ? tag.displayNameOverride : tag.displayName;

                    return (
                        <Link to={tagUrl}
                              onClick={(e) => this.onSearchTagClick(tagText, tagUrl)}>
                            { tagText }
                        </Link>
                    );

                })}
                onMetadataToggle={this.onMetadataToggle}
                onShare={this.onShare}
                shareModalConfig={{...shareModalConfig, embedElement}}
                dictionary={dictionary}
            />
        );

    }

}

MetadataWrapper.propTypes = {
    clipData: PropTypes.object,
    shareModalConfig: PropTypes.object,
    dictionary: PropTypes.object,
};

MetadataWrapper.defaultProps = {
    clipData: {},
    lang: 'en',
    shareModalConfig: {},
    dictionary: {},
};

export default MetadataWrapper;
